import Intercom from '@intercom/messenger-js-sdk';
import type { PropsWithChildren } from 'react';
import type React from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { authSelector, issuerSelector, userSelector } from '../../selectors';

export const IntercomProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const {
    name: { first: firstName, last: lastName, email: userEmail },
    id: userId,
  } = useSelector(userSelector);
  const { isAuthenticated } = useSelector(authSelector);
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { intercom_workspace_id } = useSelector(issuerSelector);
  const userNameAsOneString =
    [firstName, lastName].filter(Boolean).join(' ') || undefined;
  // In case it's an empty string, we set it to undefined:
  const emailToProvide = userEmail || undefined;

  useEffect(() => {
    if (isAuthenticated && intercom_workspace_id) {
      Intercom({
        app_id: intercom_workspace_id,
        user_id: String(userId),
        name: userNameAsOneString,
        email: emailToProvide,
      });
    }
  }, [
    emailToProvide,
    intercom_workspace_id,
    isAuthenticated,
    userId,
    userNameAsOneString,
  ]);

  return children;
};
